import styled from 'styled-components';

export const MethodsPaymentsListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
